import axios from 'axios';

import { IAffEvenementKiosque } from '@/shared/model/aff-evenement-kiosque.model';

const baseApiUrl = 'api/aff-evenement-kiosques';

export default class AffEvenementKiosqueService {
  public find(id: number): Promise<IAffEvenementKiosque> {
    return new Promise<IAffEvenementKiosque>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAffEvenementKiosque): Promise<IAffEvenementKiosque> {
    return new Promise<IAffEvenementKiosque>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IAffEvenementKiosque): Promise<IAffEvenementKiosque> {
    return new Promise<IAffEvenementKiosque>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
